import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";

export const RELAUNCH = {
  slug: "extras-tv-is-back",
  title: "Your Opportunity to Be on Screen",
  subtitle: "TV. Film. Advertising. Be part of the action.",
  paragraphs: [
    "Extras.tv is back! With a history of supplying extras for television programmes, the feature film Heartlands and brand advertising, we're relaunching with a fresh vision for the digital age.",
    "Create your profile, showcase yourself and take the first step towards potential opportunities in television and film.",
  ],
};

export const Announcement = () => (
  <section className="border-b border-white/10 bg-[hsl(0,0%,4%)]" data-testid="announcement-section">
    <div className="max-w-7xl mx-auto px-6 md:px-10 py-14 md:py-20 grid md:grid-cols-12 gap-8 md:gap-12 items-end">
      <div className="md:col-span-7">
        <p className="label-xs text-primary fade-up">News · Relaunch</p>
        <h2 className="font-display text-4xl sm:text-5xl lg:text-6xl font-bold mt-4 leading-[0.95] fade-up" style={{ animationDelay: "80ms" }} data-testid="announcement-title">
          {RELAUNCH.title}
        </h2>
        <p className="font-display text-lg md:text-xl text-white/80 mt-4 fade-up" style={{ animationDelay: "140ms" }} data-testid="announcement-subtitle">
          {RELAUNCH.subtitle}
        </p>
      </div>
      <div className="md:col-span-5 fade-up" style={{ animationDelay: "200ms" }}>
        {RELAUNCH.paragraphs.map((p) => (
          <p key={p} className="text-white/70 leading-relaxed mb-4">{p}</p>
        ))}
        <Link to={`/news/${RELAUNCH.slug}`} className="inline-flex items-center gap-2 text-primary font-bold uppercase text-sm tracking-wider group mt-2" data-testid="announcement-read-more">
          Read more <ArrowRight size={16} className="group-hover:translate-x-1 transition-transform" />
        </Link>
      </div>
    </div>
  </section>
);
